<button
  [disabled]="disabled"
  class="cf-btn btn btn-{{ size }} cf-btn-{{ color }} {{ className ? className : '' }} {{ btnStyle }}"
  type="{{ type }}"
>
  <ng-container
    *ngIf="
      ((loadingService.loadingState$ | async) && isLoadingBtn && thisTargetClicked) || loadingState;
      else contentTmp
    "
  >
    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    {{ "common.loading" | translate }}
  </ng-container>
  <ng-template #contentTmp>
    <ng-content></ng-content>
  </ng-template>
</button>
